import React from "react";
import {CreateUser} from "./CreateUser";

export class EditUser extends CreateUser {
    protected needMount: boolean = true;

    protected getRequestUrl(): RequestInfo | URL {
        return '/user/update';
    }

    componentDidMount() {
        let [id] = this.getParams();

        this.request.fetch('/user/get/' + id)
            .then((data: { item: { [key: string]: string }, rights: string[] } | any) => {
                this.setState({item: data.item, rights: data.rights});
            }).catch(error => {
            this.onError(error);
        });
    }

    protected onSuccess(data: any, event: React.FormEvent | null): any {
        this.setState(null);
        (document.querySelector('form .alert.alert-success') as HTMLElement).classList.remove('hide');
    }
}
